import i18n from 'modules/core/lib/i18n'

import RoundTripField from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/mileage/RoundTrip/RoundTripField'
import Trip from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/mileage/Trip'
import FormBlock from 'modules/expenses/components/expenses/Detail/_newForm/Sections/FormBlock'
import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

interface Props extends PermissionsProps, CustomizationProps {
  setIsCalculatingDistance?: (loading: boolean) => void
}

const TripInformation = (props: Props) => {
  return (
    <FormBlock
      title={i18n.t('expenses_v2.forms.new_form.blocks.trip_information')}
      subtitle={i18n.t('expenses_v2.forms.new_form.blocks.trip_information_subtitle')}
    >
      <Trip {...props} />
      <RoundTripField {...props} />
    </FormBlock>
  )
}
export default TripInformation
